export const YM_ID = Number(process.env.REACT_APP_YM_ID || 0);

function enqueueYmCall(args: IArguments | any[]) {
    const w = window as any;
    if (typeof w.ym !== 'function') {
        w.ym = function () {
            (w.ym.a = w.ym.a || []).push(arguments);
        };
    }
    (w.ym.a = w.ym.a || []).push(args);
}

export function reachGoal(goal: 'ORDER_SUCCESS' | 'ADD_TO_CART' | 'PHONE_CLICK' | (string & {}), params?: Record<string, unknown>) {
    if (process.env.NODE_ENV !== 'production') return;
    if (!YM_ID) return;
    const ym = window.ym;
    if (typeof ym === 'function') {
        ym(YM_ID, 'reachGoal', goal, params);
    } else {
        enqueueYmCall([YM_ID, 'reachGoal', goal, params]);
    }
}

export function getClientId(): Promise<string | null> {
    return new Promise((resolve) => {
        if (process.env.NODE_ENV !== 'production' || !YM_ID) return resolve(null);
        const ym = window.ym;
        if (typeof ym === 'function') {
            try {
                ym(YM_ID, 'getClientID', (cid: string) => resolve(cid ?? null));
            } catch {
                resolve(null);
            }
        } else {
            setTimeout(() => {
                try {
                    window.ym?.(YM_ID, 'getClientID', (cid: string) => resolve(cid ?? null));
                } catch {
                    resolve(null);
                }
            }, 500);
        }
    });
}

export type YMEcommerceEvent = { ecommerce: Record<string, unknown> };
export function pushEcommerce(event: YMEcommerceEvent) {
    if (process.env.NODE_ENV !== 'production') return;
    if (!YM_ID) return;
    const w = window as any;
    if (!Array.isArray(w.dataLayer)) {
        w.dataLayer = [];
    }
    w.dataLayer.push(event);
}
